import { Link, NavLink } from "react-router-dom";
import styles from "../styles/Site.module.css";

const NAV = [
    { to: "/research", label: "Research" },
    { to: "/blog", label: "Blog" },
    { to: "/book-reviews", label: "Book Reviews" },
];

interface LayoutProps {
    children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
    return (
        <div className={styles.page}>
            <div className={styles.frame}>
                <header className={styles.header}>
                    <Link to="/" className={styles.wordmark}>
                        Alec Dewulf
                    </Link>
                    <nav className={styles.nav} aria-label="Primary">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                className={({ isActive }) => (isActive ? styles.active : undefined)}
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>
                </header>
                <main className={styles.main}>{children}</main>
            </div>
        </div>
    );
};

export default Layout;
